import React from 'react'

import Collapsible from 'components/ui/Collapsible/Collapsible'
import LayersToggleLink from '../../LayersToggleLink/LayersToggleLink'

import s from './MarketplaceCollapsibleList.scss'


const MarketplaceCollapsibleList = ({ children, className, title, isSelected, onClick }) => (
  <div className={className}>
    <LayersToggleLink
      className={s.link}
      titleClassName={s.title}
      title={title}
      arrowDirection={isSelected ? 'down' : 'up'}
      onClick={onClick}
    />
    <Collapsible
      collapsed={!isSelected}
    >
      {children}
    </Collapsible>
  </div>
)


export default MarketplaceCollapsibleList
